<div class="page column center">
  <img src="assets/img/logo-type.png">
  <p translate>404.not-found</p>
  <a class="success" [routerLink]="['/']" translate>404.return</a>
</div>